import { UPDATE_BENEFIT_PACK, UPDATE_BENEFIT_PACK_SUCCESS, UPDATE_BENEFIT_PACK_ERROR, UPDATE_BENEFIT_PACK_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateBenefitPack = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_BENEFIT_PACK:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_BENEFIT_PACK_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_BENEFIT_PACK_ERROR:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case UPDATE_BENEFIT_PACK_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateBenefitPack;
